import _ from 'lodash';
import moment from 'moment-timezone';
import api from '../../utils/service';
import { downloadJsonFile } from '../../utils/download';
import { loadingCycle } from './page';

const GET_ALL_PAYMENT_RECORDS_SUCCESS = 'redux/paymentRecord/GET_ALL_PAYMENT_RECORDS_SUCCESS';
const GET_ALL_PAYMENT_RECORDS_FAIL = 'redux/paymentRecord/GET_ALL_PAYMENT_RECORDS_FAIL';
const GET_PAYMENT_RECORD_SUCCESS = 'redux/paymentRecord/GET_PAYMENT_RECORD_SUCCESS';
const GET_PAYMENT_RECORD_FAIL = 'redux/paymentRecord/GET_PAYMENT_RECORD_FAIL';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_PAYMENT_RECORDS_SUCCESS:
      return {
        ...state,
        list: action.data,
        error: null,
      };
    case GET_PAYMENT_RECORD_SUCCESS:
      return {
        ...state,
        paymentRecord: action.data,
        error: null,
      };
    case GET_ALL_PAYMENT_RECORDS_FAIL:
    case GET_PAYMENT_RECORD_FAIL:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

export function getAllPaymentRecords() {
  return (dispatch) =>
    loadingCycle(api.get('/payment-records'))
      .then(({ data }) => dispatch(getAllPaymentRecordsSuccess(data)))
      .catch((error) => dispatch(getAllPaymentRecordsFail(error)));
}

export function getAllPaymentRecordsSuccess(data) {
  return {
    type: GET_ALL_PAYMENT_RECORDS_SUCCESS,
    data,
  };
}

export function getAllPaymentRecordsFail(error) {
  return {
    type: GET_ALL_PAYMENT_RECORDS_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}

export function getPaymentRecord(id) {
  return (dispatch) =>
    loadingCycle(api.get(`/payment-records/${id}`))
      .then(({ data }) => {
        downloadJsonFile(
          data,
          `DEALER ${_.get(data, 'dealerId')} PAYMENT ${moment(_.get(data.created)).format(
            'YYYYMMDD',
          )}`,
        );
        return dispatch(getPaymentRecordSuccess(data));
      })
      .catch((error) => dispatch(getPaymentRecordFail(error)));
}

export function getPaymentRecordSuccess(data) {
  return {
    type: GET_PAYMENT_RECORD_SUCCESS,
    data,
  };
}

export function getPaymentRecordFail(error) {
  return {
    type: GET_PAYMENT_RECORD_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}
